/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2293ecb34a28cc463c42a76dd4e98b3f>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "AiSparkle".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-sparkle
 * Usage guidance:
 * Reserved for representing AI-powered features and functionality.
 * 
 * Note: The "Editions" gem icon has replaced the sparkle icon for representing premium features in upsell experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const AiSparkleIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "AiSparkleIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 11.5V13H16v1.5h-1.5V16H13v-1.5h-1.5V13H13v-1.5zM8 1c.31 0 .587.19.7.479l1.63 4.19 4.192 1.632a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.192a.75.75 0 0 1-1.398 0L5.67 10.33 1.479 8.7a.75.75 0 0 1 0-1.398l4.19-1.631L7.301 1.48l.05-.104A.75.75 0 0 1 8 1M6.95 6.521a.75.75 0 0 1-.429.428L3.82 8l2.702 1.05a.75.75 0 0 1 .428.429l1.05 2.7 1.05-2.7.033-.073a.75.75 0 0 1 .396-.355L12.179 8l-2.7-1.05a.75.75 0 0 1-.428-.429L8 3.82zM3 0v1.5h1.5V3H3v1.5H1.5V3H0V1.5h1.5V0z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
AiSparkleIcon.displayName = 'AiSparkleIcon';
var _default = exports.default = AiSparkleIcon;